<template>
  <div class="bc-print-root">
    <div class="bc-label">
      <barcode
        v-if="code"
        :value="code"
        format="CODE128"
        :height="55"
        :width="2"
        :displayValue="false"
        class="bc-barcode"
      />
      <div class="bc-code">{{ code }}</div>
      <div class="bc-name">{{ name }}</div>
    </div>
    <div v-if="!code" class="bc-empty">Barkod verisi yok.</div>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";

export default {
  components: { barcode: VueBarcode },
  data: () => ({
    code: "",
    name: "",
  }),
  mounted() {
    this.$store.commit("SET_LAYOUT", "empty-layout");
    const params = new URLSearchParams(window.location.search);
    this.code = params.get("code") || "";
    this.name = params.get("name") || "";
    if (this.code) {
      this.$nextTick(() => window.print());
    }
  },
};
</script>

<style scoped>
.bc-print-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}
.bc-label {
  width: 5cm;
  height: 3cm;
  background: #fff;
  border: 1px solid #ddd;
  box-sizing: border-box;
  padding: 0.25cm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Arial, Helvetica, sans-serif;
}
.bc-barcode {
  display: block;
}
.bc-barcode >>> svg {
  max-width: 100%;
  height: auto;
}
.bc-code {
  font-size: 11px;
  letter-spacing: 1px;
  margin-top: 2px;
}
.bc-name {
  font-size: 13px;
  font-weight: 700;
  margin-top: 2px;
  text-align: center;
  line-height: 1.1;
}
.bc-empty {
  padding: 40px;
  color: #666;
}
</style>

<style>
@page {
  size: 5cm 3cm;
  margin: 0;
}
@media print {
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }
  .bc-print-root {
    background: #fff !important;
    padding: 0 !important;
    min-height: 0 !important;
    display: block !important;
  }
  .bc-label {
    border: none !important;
  }
}
</style>
